import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'myHours' })
export class MyHoursPipe implements PipeTransform {
    constructor() { }

    transform(hoursNum: number): string {
        if (hoursNum) {
            const isMinus = hoursNum < 0;
            hoursNum = Math.abs(hoursNum);
            const hours = Math.floor(hoursNum);
            const minutes = Math.round((hoursNum - hours) * 60);
            return `${isMinus?'-':''}${hours}:${minutes.toString().padStart(2, '0')}`;

        }
        return ''
    }
} 
